import React, { useEffect, useRef, useState } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { getemployeeDetailsReport } from "../../features/reports/employeeDetailReport/reportsApi";
import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Button,
  Divider,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAccountReachageDetails,
  getAllEmployeeList,
} from "./appoinmentDashboardApi";
import SmbAccountReachargeCard from "./AppoinmentDashboardCard";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { getData } from "./smbAccountRechargeCustomApiHandler";

import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerComponent from "../../common/curstomDatePicker";
import FormModal from "./FormModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import EmployeeDetail from "./educationalDetail";
import ExpenceEmp from "./expenceEmp";
import CardPayment from "../payment/cardPayment";
import FormModalShareMessageProfile from "./formDataShareMessage";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import EmployeeAttendace from "./empAttendace";
import AssociatedUsers from "../associatedUsers/associatedUsers";
import PaymentStruct from "../payment/payment";
import EmployeePayRoll from "../employeePayRoll/employeePayRol";
import { ArrowBackIcon } from "../../common/icon";
import { useNavigate } from "react-router";

export default function EmployeeInfo({ gridSize, config }) {
  const cardKet = {
    persnoalInf: [
      {
        key: "employeeId",
        label: "Employee Id",
        color: "#bb4a9b",
      },
      {
        key: "name",
        label: "Employee Name",
        color: "#bb4a9b",
      },
      {
        key: "address",
        color: "black",
        label: "Address",
      },
      {
        key: "mobile",
        color: "black",
        label: "Mobile",
      },
      {
        keys: ["paymentPercentage", "salaryorPercentage"],
        color: "#3695B6",
        label: "Payment Percentage",
      },
    ],
    educationalDetail: [
      {
        key: "courseName",
        label: "Course Name",
      },
      {
        key: "courseDetails",
        label: "Component Name",
      },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "grade",
      },
      {
        key: "institute",
        label: "institute",
      },
      {
        key: "university",
        label: "university",
      },
    ],

    incentrive: [
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };
  // const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const datePickerRef = useRef();
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [date, setDate] = useState(getStartOfMonth());

  const [SelectedStartDate, setSelectedStartDate] = useState(
    getFirstDateOfMonth(),
  );
  const [openT, setOpenT] = useState(false);
  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);
  const [cardValue, setCardValue] = useState(null);

  const [modalData, setModalData] = useState(null);
  const [modalDataT, setModalDataT] = useState(null);
  const [value, setValue] = React.useState("Unassigned");
  const [data, setData] = useState();
  const [valuet, setValuet] = React.useState("Assigned");
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const handleChanget = (event, newValue) => {
    // setPageNo(1);

    setValuet(newValue);
  };

  useEffect(() => {
    getAllEmployeeList((res) => {
      console.log("getAllEmployeeList", res);
      setData(res?.list);
    });
    // getData(getAccountReachageDetails, setData);
  }, []);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);

  const handleOpenDatePicker = () => {
    setIsDatePickerOpen(true);
  };

  const handleCloseDatePicker = () => {
    setIsDatePickerOpen(false);
  };
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);
  useEffect(() => {
    console.log("modalData parent", data);
  }, [data]);
  useEffect(() => {
    if (open == false) {
      // setModalData({});
    }
  }, [open]);

  const downloadXLSXFile = async (employeeData) => {
    try {
      const response = await getemployeeDetailsReport(employeeData, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const dateStr = new Date().toISOString().slice(0, 10);
      link.setAttribute("download", `employee_report_${dateStr}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      {(businessChooseTab?.value === "PersnalInfo" || config?.personalInfo) && (
        <Box
          px={2}
          // px={{ sm: 4, xs: 2 }}
          pb={4}
          container="true"
          sx={{
            paddingTop: "15px",
            backgroundColor: "#E3E3FF",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          <Grid container>
            {/* <Grid container alignItems="center" spacing={2}> */}
            {/* Back Icon */}
            <Grid container alignItems="center" spacing={2}>
              <Grid
                item
                sx={
                  {
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                  }
                }
                // xs={2}
                // md={1}
                // sm={1}
              >
                <ArrowBackIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate("/home")}
                />
              </Grid>
              <Grid
                item
                xs

                // xs={10}
                // md={9}
                // sm={8}
                // sx={{
                //   background:
                //     "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                //   padding: "10px",

                //   // mt: "10px",
                //   borderRadius: "5px",
                //   color: "#01008B", // optional text color
                //   textAlign: "left",
                //   marginBottom: "20px",
                //   fontFamily: "'Montserrat', sans-serif",
                //   fontSize: { xs: "12px", sm: "13px", md: "15px" },
                //   fontWeight: 500,
                // }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                    padding: "10px",
                    mt: "10px",
                    borderRadius: "5px",
                    color: "#01008B",
                    textAlign: "left",
                    marginBottom: "20px",
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "20px",
                    fontWeight: 500,
                  }}
                >
                  <Typography
                    variant="h6"
                    fontSize={{ xs: "12px", sm: "13px", md: "18px" }}
                  >
                    {config?.title
                      ? config?.title
                      : config?.personalInfo
                        ? "Share Employee Profile"
                        : "Employee Personal Information"}
                  </Typography>
                </Box>
              </Grid>
              {/* </Grid> */}
              {config?.downloadIcon && (
                <Grid
                  item
                  md={2}
                  sm={3}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingRight: { sm: "10px", xs: "0px", md: "30px" },
                  }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      console.log("clicked");
                      downloadXLSXFile();
                    }}
                    sx={{
                      height: "40px",
                      backgroundColor: "#14008B",
                      fontWeight: 600,
                      // width: "68px",
                      padding: "0px",
                      marginBottom: "10px",
                    }}
                    endIcon={<FileDownloadIcon />}
                  >
                    Download
                  </Button>
                </Grid>
              )}
            </Grid>

            {!config?.hideSeachField && (
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={8} md={9} lg={10}>
                  <TextField
                    value={search?.name || ""}
                    placeholder="Search"
                    size="small"
                    fullWidth
                    variant="outlined"
                    onClick={() => setSearchModal(true)}
                    sx={{
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: "6px",
                      // color: "#555555",
                      "& .MuiOutlinedInput-root": {
                        border: "none",
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          border: "none",
                        },
                        "&.Mui-focused fieldset": {
                          border: "none",
                        },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#555555",
                        opacity: 6,
                        fontWeight: 500,
                        cursor: "pointer",
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          {search?.name ? (
                            <CloseIcon
                              sx={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSearchvalue("");
                                setCardValue(null);
                                getAllEmployeeList((res) => {
                                  setData(res?.list);
                                });
                              }}
                            />
                          ) : (
                            <Box
                              onClick={() => setSearchModal(true)}
                              sx={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <SearchIcon color="primary" />
                            </Box>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />

                  <PoprchModal
                    cardValue={cardValue}
                    setCardValue={(data) => {
                      setSearchvalue(data);
                      setCardValue(data);
                      setData([data]);
                    }}
                    callback={() => {}}
                    searchModal={searchModal}
                    setSearchModal={setSearchModal}
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={2} sx={{ padding: "0px" }}>
                  {!gridSize && !config && (
                    <Button
                      fullWidth
                      onClick={() => setOpen(true)}
                      sx={{
                        textTransform: "capitalize",
                        width: { xs: "100%", sm: "auto" },
                        whiteSpace: "nowrap",
                        zIndex: "0",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      size="medium"
                      color="primary"
                      variant="contained"
                      aria-label="add"
                    >
                      Add Employee
                      <AddIcon sx={{ marginLeft: "6px" }} />
                    </Button>
                  )}
                </Grid>
              </Grid>
            )}
            {/* </Grid> */}
            <Grid
              container
              sx={{
                p: { xs: "1px", sm: "10px" },
                mt: 2,
                background: "white",
                borderRadius: "12px",
                overflowX: "auto",
              }}
            >
              <Box sx={{ minWidth: "600px" }}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid
                      container
                      sx={{
                        borderBottom: "1.5px solid black",
                        padding: "10px",
                      }}
                    >
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            textAlign: "center",
                            fontWeight: 500,
                            color: "#01008B",
                          }}
                        >
                          Employee Id
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            textAlign: "center",
                            fontWeight: 500,
                            color: "#01008B",
                          }}
                        >
                          Employee Name
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            textAlign: "center",
                            fontWeight: 500,
                            color: "#01008B",
                          }}
                        >
                          Address
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            textAlign: "center",
                            fontWeight: 500,
                            color: "#01008B",
                          }}
                        >
                          Mobile No.
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            textAlign: "center",
                            fontWeight: 500,
                            color: "#01008B",
                          }}
                        >
                          Payment Mode
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      height: "60vh",
                      overflowY: "auto",
                      marginTop: "10px",
                      padding: "15px",
                    }}
                  >
                    {Array.isArray(data) && data.length > 0 ? (
                      data.map((row, index) => (
                        <Grid
                          container
                          key={row?.id || index}
                          onClick={
                            config?.onclickFalse
                              ? undefined
                              : () => {
                                  const cleaned = {};
                                  Object.keys(row).forEach((key) => {
                                    cleaned[key] =
                                      row[key] && row[key] !== "null"
                                        ? row[key]
                                        : "";
                                  });
                                  if (!config) {
                                    setModalData(cleaned);
                                    setOpen(true);
                                  } else {
                                    setModalDataT(cleaned);
                                    setOpenT(true);
                                  }
                                }
                          }
                          sx={{
                            p: "8px 0px",
                            borderBottom: "1px solid #eee",
                            alignItems: "center",
                            backgroundColor: "#E8E8FF",
                            borderRadius: "8px",
                            mb: 1,
                            cursor: "pointer",
                          }}
                        >
                          <Grid
                            item
                            xs={2}
                            sx={{ pl: { xs: 2, sm: 2, md: 2, lg: 6 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {row?.employeeId || "-"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            sx={{ pl: { xs: 2, sm: 2, md: 4, lg: 11 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {row?.name || "-"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{ pl: { xs: 3, sm: 2, md: 4, lg: 9 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {row?.address || "-"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            sx={{ pr: { xs: 2, sm: 2, md: 6, lg: 12 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "right",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {row?.mobile || "-"}
                            </Typography>
                          </Grid>
                          <Grid item xs={2} sx={{ pr: 2 }}>
                            <Typography
                              sx={{
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {row?.salaryorPercentage === true
                                ? "Salary"
                                : row?.salaryorPercentage === false &&
                                    typeof row?.paymentPercentage === "number"
                                  ? `Percentage (${row?.paymentPercentage}%)`
                                  : "-"}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))
                    ) : (
                      <Typography align="center">
                        No employee data available
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {/* Modals */}
            <FormModal
              open={open}
              setModalData={setModalData}
              setOpen={setOpen}
              getAll={() => {
                getAllEmployeeList((res) => {
                  setData(res?.list);
                });
              }}
              modalData={modalData}
            />
            <FormModalShareMessageProfile
              open={openT}
              setOpen={setOpenT}
              getAll={() => {
                getAllEmployeeList((res) => {
                  setData(res?.list);
                });
              }}
              modalData={modalDataT}
            />
          </Grid>
        </Box>
      )}

      {businessChooseTab?.value === "EducatoinalDetail" && <EmployeeDetail />}
      {businessChooseTab?.value === "expence" && <ExpenceEmp />}
      {businessChooseTab?.value === "attendance" && <EmployeeAttendace />}
      {businessChooseTab?.value === "associate" && <AssociatedUsers />}
      {(businessChooseTab?.value === "SalaryComponents" ||
        businessChooseTab?.value === "incentive" ||
        businessChooseTab?.value === "otherAllowence" ||
        businessChooseTab?.value === "Deductions") && <PaymentStruct />}
      {(businessChooseTab?.value == "AdvancePayment" ||
        businessChooseTab?.value == "settledandpaidAmount" ||
        businessChooseTab?.value == "Salary") && <EmployeePayRoll />}
    </>
  );
}
